module.exports = __webpack_public_path__ + "static/7-7d0133dcea100359ebb942c0d5f0fdb0.png";